import { useUserStore } from "store";
import { extractTenantId, type PageAccess, explodeGroups } from "@login";
import type { UsuarioResponse, Filial } from "@apiUser";
import type { AuthResponse, AuthData } from "@login";

/**
 * Hook para persistir todos os dados do usuário no Zustand/Local Storage após login.
 * Recebe os dados completos e salva nos locais corretos.
 */
export function usePersistUserData() {
  const setUserData = useUserStore((s) => s.setUserData);

  return ({
    usuarioResponse,
    pageAccess,
    authData,
  }: {
    usuarioResponse: UsuarioResponse;
    pageAccess: PageAccess;
    authData: AuthResponse;
  }) => {
    const { usuario, grupos, cadastros } = usuarioResponse;
    const { condicoesPagamento = [], centrosCusto = [] } = cadastros || {};
    // Monta UserData
    const userData = {
      ...usuario,
      name: usuario.login,
      userDisplay: usuario.nome || usuario.login,
      userInitials: (usuario.nome || usuario.login).slice(0, 2).toUpperCase(),
      avatarUrl: null,
    };
    // Filiais extraídas dos grupos (sem duplicatas)
    const { filiais } = explodeGroups(grupos);
    // Monta AuthData completo
    const auth: AuthData = {
      tenantId: extractTenantId(grupos),
      token: authData.access_token,
      refreshToken: authData.refresh_token,
      expiresAt: new Date(Date.now() + authData.expires_in * 1000),
    };
    setUserData({
      user: userData,
      auth,
      grupos,
      filiais,
      pageAccess,
      centrosCusto,
      condicoesPagamento,
    });
  };
}
